// extracted by mini-css-extract-plugin
module.exports = {"TipBox":"_ESs5RtoRnEOM2noXCHtx","TipBoxIcon":"Kpurzrrp9G2lP-D9VHNlL"};